import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [student, setStudent] = useState(null);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path ? "active-link" : "";

  // Check if student is logged in
  useEffect(() => {
    const checkLogin = () => {
      const token = localStorage.getItem("studentToken");
      const data = localStorage.getItem("studentData");
      if (token && data) {
        try { setStudent(JSON.parse(data)); }
        catch { setStudent(null); }
      } else {
        setStudent(null);
      }
    };
    checkLogin();
    // Re-check on storage change (e.g., after login/logout in another tab)
    window.addEventListener("storage", checkLogin);
    return () => window.removeEventListener("storage", checkLogin);
  }, [location]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("studentToken");
    localStorage.removeItem("studentData");
    setStudent(null);
    setDropdownOpen(false);
    setMenuOpen(false);
    navigate("/");
  };

  const BASE_URL = "http://localhost:5000";

  const getInitial = (name) => name ? name.charAt(0).toUpperCase() : "S";

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="logo-link">
          <img
            src="/webmok-logo.png"
            alt="Web Mok Logo"
            className="brand-logo"
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <span className="brand-fallback-text" style={{ display: 'none', alignItems: 'center', gap: '4px' }}>
            <span style={{ color: '#0b4f6c', fontWeight: 800, fontSize: '22px' }}>Web</span>
            <span style={{ color: '#00aacc', fontWeight: 800, fontSize: '22px' }}>Mok</span>
          </span>
        </Link>

        {/* Hamburger */}
        <div className={`menu-icon ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span><span></span><span></span>
        </div>

        {/* Menu */}
        <div className={`nav-menu ${menuOpen ? "active" : ""}`}>
          <div className="nav-links">
            <Link to="/" className={`nav-item ${isActive("/")}`} onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/students" className={`nav-item ${isActive("/students")}`} onClick={() => setMenuOpen(false)}>Students</Link>
            <Link to="/fees" className={`nav-item ${isActive("/fees")}`} onClick={() => setMenuOpen(false)}>Fees</Link>
            <Link to="/reports" className={`nav-item ${isActive("/reports")}`} onClick={() => setMenuOpen(false)}>Reports</Link>
          </div>

          <div className="nav-buttons">
            {student ? (
              /* ── Logged-in Student Profile ── */
              <div className="nb-profile-wrap" ref={dropdownRef}>
                <button
                  className="nb-profile-btn"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  title={student.name}
                >
                  <div className="nb-avatar">
                    {student.profileImage ? (
                      <img src={`${BASE_URL}${student.profileImage}`} alt={student.name}
                        onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
                    ) : null}
                    <span className={`nb-avatar-initial ${student.profileImage ? 'hidden' : ''}`}>
                      {getInitial(student.name)}
                    </span>
                  </div>
                  <span className="nb-name">{student.name?.split(" ")[0]}</span>
                  <span className={`nb-chevron ${dropdownOpen ? "up" : ""}`}>▾</span>
                </button>

                {dropdownOpen && (
                  <div className="nb-dropdown">
                    {/* Header */}
                    <div className="nb-dropdown-header">
                      <div className="nb-dropdown-avatar">
                        {student.profileImage ? (
                          <img src={`${BASE_URL}${student.profileImage}`} alt={student.name}
                            onError={(e) => { e.target.style.display = 'none'; }}/>
                        ) : (
                          <span>{getInitial(student.name)}</span>
                        )}
                      </div>
                      <div>
                        <p className="nb-dropdown-name">{student.name}</p>
                        <p className="nb-dropdown-email">{student.email}</p>
                      </div>
                    </div>

                    <div className="nb-dropdown-divider" />

                    <Link
                      to="/student-dashboard"
                      className="nb-dropdown-item"
                      onClick={() => { setDropdownOpen(false); setMenuOpen(false); }}
                    >
                      <span>📊</span> My Dashboard
                    </Link>

                    <Link
                      to="/student-dashboard"
                      className="nb-dropdown-item"
                      onClick={() => { setDropdownOpen(false); setMenuOpen(false); }}
                    >
                      <span>👤</span> My Profile
                    </Link>

                    <div className="nb-dropdown-divider" />

                    <button className="nb-dropdown-item nb-logout-btn" onClick={handleLogout}>
                      <span>🚪</span> Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              /* ── Guest Buttons ── */
              <>
                <Link to="/login" className="btn-login" onClick={() => setMenuOpen(false)}>Login</Link>
                <Link to="/signup" className="btn-signup" onClick={() => setMenuOpen(false)}>Sign Up</Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;